import React from 'react';
import Alert from 'react-bootstrap/lib/Alert';
import Modal from 'react-bootstrap/lib/Modal';
import ReactDOMServer from 'react-dom/server';
import { Parallax } from 'react-parallax';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectDonationInfor } from './selectors';
// import UserTweets from './UserTweets';
import {
  makeSelectIsAuthenticated,
  makeSelectProfile,
} from '../AuthProvider/selectors';
import { makeSelectTotalData } from '../HomePage/selectors';
import { makeSelectCurrentLanguage } from '../Language/selectors';
import { makeSelectCurrentLang } from '../MetadataProvider/selectors';
import {
  hideLoadingFullScreen,
  stopPollingPaymentIntentStatus,
} from '../PaymentModal/actions';
import {
  makeSelectIsTrial,
  makeSelectLoading,
  makeSelectModal,
  makeSelectPrices,
  makeSelectSinglePricePremiums,
  makeSelectTrial,
  makeSelectIsCountdownActive,
} from '../PaymentModal/selectors';
import withI18next from '~/../hocs/_withI18next';
import FontIcomoonIcon from '~/components/FontIcomoonIcon';
import LoadingDefault from '~/components/LoadingDefault';
import BenefitPremiumComponent from '~/components/RegisterPremium/BenefitPremium';
import Bonus from '~/components/RegisterPremium/Bonus';
import FAQComponent from '~/components/RegisterPremium/FAQComponent';
import GiftListComponent from '~/components/RegisterPremium/GiftList';
import PricePremiumComponent from '~/components/RegisterPremium/PricePremiumComponent';
// import ScrollTop from '~/components/scroll-top/ScrollTop';
import Config from '~/config';
// import PaymentModalContainer from '~/containers/PaymentModal/Loadable';
import PaymentModalContainer from '~/containers/PaymentModal';
import { makeSelectCountdownDiscount } from '~/containers/RegisterPremiumPage/selectors';
import Breadcrumb from '~/components/Breadcrumb';
import { formatNumberWithCommas } from '~/utils/formatter';
import BannerDiscount from '~/components/BannerDiscount';
import themeVariables from '~/shared/themeVariables';

const roles = Config.getRoles();

@withI18next()
class PremiumContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalMessage: false,
      modalIframePreset: true,
    };
  }

  onRegisterPremium = async () => {
    const scroll = await import('react-scroll');
    scroll.animateScroll.scrollToTop({
      delay: 10,
      smooth: true,
    });
  };

  handleClose = () => {
    this.setState({ modalMessage: false });
  };

  getHeaderImage() {
    switch (Config.serviceType) {
      case 'silhouette_ac':
        return '/static/assets/image/premium/credit-card/sil_back.jpg';
      case 'illust_ac':
        return '/static/assets/image/premium/header_illust.jpg';
      case 'design_ac':
        return '/static/assets/image/premium/credit-card/back1.jpg';
      case 'photo_ac':
        return '/static/assets/image/premium/header_photo.jpg';
      default:
        return '/static/assets/image/premium/credit-card/back.jpg';
    }
  }

  cancelWechatPayment = () => {
    this.props.stopPollingPaymentIntentStatus();
    this.props.hideLoadingFullScreen();
  };

  render() {
    const {
      t,
      isAuthenticated,
      currentLang,
      isTrial,
      plans,
      loading,
      donation,
      totalData,
      profile,
      singlePricePremiums,
      testModal,
      isCountdownActive,
      stripe,
    } = this.props;

    const loadingMessage =
      loading.fullScreen && t('register_premium_message_pay');
    const countDesign = totalData
      ? Math.floor(totalData.design_ac / 100) * 100
      : Config.totalData.design_ac;
    const countPhoto = totalData
      ? Math.floor(totalData.photo_ac / 100) * 100
      : Config.totalData.photo_ac;
    const countIllust = totalData
      ? Math.floor(totalData.illust_ac / 100) * 100
      : Config.totalData.illust_ac;
    const countSilhouette = totalData
      ? Math.floor(totalData.silhouette_ac / 100) * 100
      : Config.totalData.silhouette_ac;

    const isDiscountDisplayed =
      profile.role !== roles.PREMIUM &&
      profile.role !== roles.CREATOR &&
      isCountdownActive;

    return (
      <div className="credit-card-new">
        <Parallax
          className="credit-card-header"
          bgImage={`${Config.staticPrefix}${this.getHeaderImage()}`}
          strength={300}
        >
          <div
            style={{
              backgroundColor: 'rgba(0, 0, 0, .45)',
              height: '100%',
              width: '100%',
              position: 'absolute',
            }}
          />

          <div className="header-wrapper">
            {!isTrial ? (
              <h1
                className="premium-title-premium"
                dangerouslySetInnerHTML={{
                  __html: t('heading_premium_page'),
                }}
              />
            ) : (
              <div>
                <div
                  className="premium-title-premium"
                  dangerouslySetInnerHTML={{
                    __html: t('preset_countdown_campaign_title', {
                      icon: ReactDOMServer.renderToString(
                        <FontIcomoonIcon
                          icon="icon-king-outline"
                          style={{ marginTop: -15 }}
                        />,
                      ),
                      service: `${Config.serviceType}`,
                    }),
                  }}
                />
                <div style={{ textAlign: 'center' }}>
                  {t('trial_limited_time_offer')}
                </div>
              </div>
            )}
            <p
              className="premium-title-premium-number"
              dangerouslySetInnerHTML={{
                __html: t('credit_premium_header_title_number', {
                  countPhoto: formatNumberWithCommas(countPhoto),
                  countIllust: formatNumberWithCommas(countIllust),
                  countSilhouette: formatNumberWithCommas(countSilhouette),
                  countDesign: formatNumberWithCommas(countDesign),
                }),
              }}
            />
          </div>
        </Parallax>
        {isDiscountDisplayed && <BannerDiscount />}

        <div className="breadcrumb-wrapper">
          <Breadcrumb title={t('heading_premium_page')} />
        </div>
        <PricePremiumComponent
          plans={plans}
          singlePricePremiums={singlePricePremiums}
        />
        <BenefitPremiumComponent
          onRegisterPremium={this.onRegisterPremium}
          profile={profile}
        />
        {/* <FeedbackComponent /> */}
        {/* <AdvantageOtherCompany /> */}
        {/* <GiftListComponent
          onRegisterPremium={this.onRegisterPremium}
          profile={profile}
        /> */}
        {/* {Config.serviceType !== 'silhouette_ac' && (
          <Parallax
            className="pt50 pb50 bg-premium-creator"
            bgImage={`/static/assets/image/premium/credit-card/${Config.getPrefixContent(
              'back2',
            )}.jpg`}
            strength={300}
          >
            <div className="container">
              <h1 className="color-white text-center pb10">{t('credit_premium_creator_title')}</h1>

              <p className="pb20 color-white">{t('credit_premium_creator_content1')}</p>
              <p className="color-white">{t('credit_premium_creator_content2')}</p>
            </div>
          </Parallax>
        )} */}
        {/* <DonateEarthquake
          onRegisterPremium={this.onRegisterPremium}
          priceMonthly={priceMonthly}
          donation={donation}
        /> */}
        <FAQComponent />
        {/* <UserTweets /> */}
        {/* <ScrollTop /> */}
        {/* <Bonus onClickRegister={this.onRegisterPremium} /> */}
        <Modal
          bsSize="small"
          show={this.state.modalMessage}
          onHide={this.handleClose}
        >
          <Modal.Body style={{ padding: 0 }}>
            <Alert bsStyle="warning">
              <h4 className="text-center" style={{ lineHeight: '1.5' }}>
                {t('credit_card_message_upgraded')}
              </h4>
            </Alert>
          </Modal.Body>
        </Modal>
        {testModal && <PaymentModalContainer />}
        <LoadingDefault
          {...loading}
          t={t}
          cancelWechatPayment={this.cancelWechatPayment}
          message={loadingMessage}
        />
        <style jsx global>
          {`
            .credit-card-new h1.text-center {
              font-size: 2em;
            }

            .credit-card-new .credit-card-header {
              background-size: cover;
              color: #fff;
              background-repeat: no-repeat;
              background-color: #dcdcdc;
              position: relative;
            }

            .credit-card-new .premium-title-premium {
              font-size: 36px;
              text-align: center;
            }

            .credit-card-new .button-header:hover {
              background: rgba(0, 0, 0, 0.77);
            }

            .credit-card-new .premium-title-premium-number {
              font-size: 15px;
              display: block;
              letter-spacing: 3px;
              text-transform: uppercase;
            }

            .credit-card-new .premium-title-description {
              font-size: 15px;
              display: block;
              text-align: center;
              padding: 0 20%;
            }

            .credit-card-new .header-wrapper {
              padding: 20px 15px;
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;
              position: relative;
            }

            .credit-card-new .premium-service-logo {
              border: 1px solid #fff;
              height: 90px;
              width: 90px;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              margin-bottom: 10px;
            }

            .credit-card-new .button-header {
              border-radius: 60px;
              height: 60px;
              background: #000000;
              border: 1px solid #fff;
              padding-left: 60px;
              padding-right: 60px;
              color: #fff;
              font-size: 20px;
            }

            .credit-card-new .people-exceeded {
              height: 130px;
              width: 130px;
              border-radius: 50%;
              right: 50px;
              bottom: 50px;
              position: absolute;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            }
            .credit-card-new .people-exceeded .price {
              font-size: 50px;
              font-weight: 700;
              line-height: 0.9;
              font-family: FuturaMedium, 'Helvetica Neue', Helvetica, Arial,
                sans-serif;
            }
            .credit-card-new .people-exceeded .price2 {
              font-size: 38px;
              font-weight: 400;
              line-height: 0.8;
            }
            .credit-card-new .people-exceeded .break-through {
              font-size: 25px;
              font-weight: 700;
            }

            .ill_color-price {
              color: #d73a4e;
            }

            .sil_color-price {
              color: #41b9b8;
            }

            .photo_color-price {
              color: #509bdc;
            }

            .design_color-price {
              color: #3e3e3f;
            }

            .ill_people-exceeded {
              background: #ffffffcf;
            }

            .design_people-exceeded {
              background: #ffa823;
            }

            .photo_people-exceeded {
              background: #ffffffcf;
            }

            .sil_people-exceeded {
              background: #ffffffcf;
            }

            .people-exceeded-small .price {
              padding: 3px 0;
              font-size: 35px !important;
            }

            .people-exceeded-small .price2 {
              font-size: 20px !important;
            }

            .people-exceeded-small .break-through {
              font-size: 15px !important;
            }

            a.benefit-premium,
            a.button-shadow {
              line-height: 1.3;
              height: 60px;
            }

            .bg-premium-creator {
              background-size: cover;
              padding: 100px 0;
            }

            .text-center-color-premium {
              color: #3e3e3f;
            }

            .campaign-title-premium {
              color: #ffa823;
            }

            .breadcrumb-wrapper {
              padding: 5px 10%;
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .breadcrumb-wrapper {
                padding: 8px 10px;
              }
            }
            .member-login-modal {
              overflow-y: scroll;
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  isAuthenticated: makeSelectIsAuthenticated(),
  profile: makeSelectProfile(),
  currentLang: makeSelectCurrentLang(),
  trial: makeSelectTrial(),
  currentLanguage: makeSelectCurrentLanguage(),
  isTrial: makeSelectIsTrial(),
  plans: makeSelectPrices(),
  singlePricePremiums: makeSelectSinglePricePremiums(),
  loading: makeSelectLoading(),
  donation: makeSelectDonationInfor(),
  totalData: makeSelectTotalData(),
  testModal: makeSelectModal(),
  isCountdownActive: makeSelectIsCountdownActive(),
});
const mapDispatchToProps = (dispatch) => ({
  stopPollingPaymentIntentStatus: () =>
    dispatch(stopPollingPaymentIntentStatus()),
  hideLoadingFullScreen: () => dispatch(hideLoadingFullScreen()),
});
export default connect(mapStateToProps, mapDispatchToProps)(PremiumContainer);
